"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _immutable = require("immutable");

var _constants = require("./constants.js");

var _ref;

var _default = new _immutable.Record((_ref = {
  author_at: null
}, (0, _defineProperty2.default)(_ref, _constants.COMPANY_CITY, null), (0, _defineProperty2.default)(_ref, _constants.COMPANY_COUNTRY, null), (0, _defineProperty2.default)(_ref, _constants.COMPANY_NAME, null), (0, _defineProperty2.default)(_ref, _constants.COMPANY_PHONE, null), (0, _defineProperty2.default)(_ref, _constants.COMPANY_STATE, null), (0, _defineProperty2.default)(_ref, _constants.COMPANY_STREET_ADDRESS_1, null), (0, _defineProperty2.default)(_ref, _constants.COMPANY_STREET_ADDRESS_2, null), (0, _defineProperty2.default)(_ref, _constants.COMPANY_ZIP, null), (0, _defineProperty2.default)(_ref, "created", null), (0, _defineProperty2.default)(_ref, "deleted_at", null), (0, _defineProperty2.default)(_ref, "id", null), (0, _defineProperty2.default)(_ref, _constants.IS_DEFAULT, null), (0, _defineProperty2.default)(_ref, _constants.NAME, null), (0, _defineProperty2.default)(_ref, "portal_id", null), (0, _defineProperty2.default)(_ref, "updated", null), _ref), _constants.CAN_SPAM_SETTING);

exports.default = _default;
module.exports = exports.default;